import PropTypes from "prop-types";
import { Box, Grid, Typography, Link } from "@mui/material";
import { useTranslation } from "react-i18next";

const AuthFooter = (props: any = null) => {
  const { t } = useTranslation();
  
  return (
    <>
      <Grid className="livis-auth-footer" minWidth={"100%"}>
        <Grid 
          item 
          lg={12} md={12} sm={12} xs={12} 
          className="livis-footer-copyright-wrap" 
          // We set the parent to relative so the absolute child stays contained
          sx={{
            position: 'relative', 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            width: '100%',
            px: 4
          }}
        >
          
          {/* LEFT: Terms and Conditions */}
          <Box>
            <Link
              href="/app/terms-and-conditions"
              underline="always"
              className="livis-footer-terms-and-conditions"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Typography variant="subtitle2" component="span" color={"grey"}>
                {t("Terms and Conditions")}
              </Typography>
            </Link>
          </Box>

          {/* CENTER: Copyright Text (Forced Center) */}
          <Box 
            sx={{ 
              position: 'absolute', 
              left: '45%', 
              transform: 'translateX(-50%)',
              width: 'max-content' 
            }}
          >
            <Typography
              variant="subtitle2"
              component="span"
              className="livis-footer-copyright-text"
              align="center"
            >
              &#169; <span>LIN</span>
              <span>CODE</span> <span>{new Date().getFullYear()}</span>
            </Typography>
          </Box>

          {/* RIGHT: Empty or Confidential (Will naturally sit on the right) */}
          <Box>
            {/* Keeping this empty as requested, but it won't affect the center now */}
          </Box>

        </Grid>
      </Grid>
    </>
  );
};

export default AuthFooter;